import withProps from 'recompose/withProps';
import MaskedInput from 'react-maskedinput';
import PlainInput from './PlainInput';


export default withProps({
  component: MaskedInput,
  mask: '111111111',
})(PlainInput);
